// Time slot
export const ALL_DAY = "ALL_DAY"
export const MORNING = "MORNING"
export const AFTERNOON = "AFTERNOON"
export const TIME_SLOT = "TIME_SLOT"
